<template>
  <ion-page>
    <ion-header class="header-container">
      <ion-toolbar class="header-toolbar">
        <ion-buttons slot="start">
          <ion-back-button
            default-href="/support-list"
            color="light"
            text=""
          ></ion-back-button>
        </ion-buttons>
        <ion-title class="page-title">How to connect wallet</ion-title>
      </ion-toolbar>
    </ion-header>
    <!--content start -->
    <ion-content>
      <ion-row>
        <ion-col>
          <p class="support-p">
            Even the all-powerful Pointing has no control bout the blind texts
            it is an almost unorthographic life One day however a small line of
            blind text by the name of Lorem Ipsum decided to leave for the far
            World of Grammar.
          </p>
          <p class="support-p">
            Even the all-powerful Pointing has no control bout the blind texts
            it is an almost unorthographic life One day however a small line of
            blind text by the name of Lorem Ipsum decided to leave for the far
            World of Grammar.
          </p>
        </ion-col>
      </ion-row>
      <hr class="support-row" />
      <!-- content end -->
    </ion-content>
  </ion-page>
</template>
<style scoped>
.header-container {
  --background: #f87e63;
}

.header-toolbar {
  --background: #f87e63;
  --border-width: 0;
  --padding-top: 8px;
  --padding-bottom: 8px;
  --min-height: 64px;
}

.page-title {
  --color: #ffffff;
  font-family: "Gilroy", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
}

.support-row {
  border-top: 1px solid #f3f3f3;
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 3%;
  padding-bottom: 3%;
}
.support-p {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #666666;
  padding-left: 5%;
  padding-right: 5%;
}
</style>
<script>
import { defineComponent } from "vue";
import {
  IonRow,
  IonCol,
  IonButton,
  IonPage,
  IonContent,
  IonIcon,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonTitle,
} from "@ionic/vue";

export default defineComponent({
  name: "SupportPostPage",
  components: {
    IonRow,
    IonCol,
    IonButton,
    IonPage,
    IonContent,
    IonIcon,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonBackButton,
    IonTitle,
  },
});
</script>
